import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IConditionalExpressionBehavior } from "../../../../documaker/domain/format/objects";

export interface IConditionalExpressionBehaviorPropertyEditable {
  conditionalExpressionBehavior(): IPropertyEditable<IConditionalExpressionBehavior>;
}

export function instanceOfIConditionalExpressionBehaviorPropertyEditable(instance: any): instance is IConditionalExpressionBehaviorPropertyEditable {
  return instance
      && instance.conditionalExpressionBehavior
      && instanceOfIPropertyEditable<IConditionalExpressionBehavior>(instance.conditionalExpressionBehavior());
}
